export function filtrer(listeAFiltrer, filtres) {
  if (!listeAFiltrer
    || listeAFiltrer.length === 0) {
    return [];
  }

  if (!filtres
    || Object.keys(filtres).length === 0) {
    return listeAFiltrer;
  }

  const listeFiltree = [];

  listeAFiltrer.forEach(element => {
    let peutEtreAjoute = true;
    Object.keys(filtres).forEach(nomFiltre => {
      const filtre = filtres[nomFiltre];
      if (filtre.valeur) {
        if (filtre.valeur.length === 0) {
          peutEtreAjoute = peutEtreAjoute && true;
        } else {
          peutEtreAjoute = peutEtreAjoute && filtre.valeur.includes(element[filtre.variable]);
        }
      }
    });
    if (peutEtreAjoute) {
      listeFiltree.push(element);
    }
  });
  return listeFiltree;
}

export function donneFiltresPourEnfant(filtres) {
  const listeFiltrePourEnfant = {};
  Object.keys(filtres).forEach(nomFiltre => {
    const filtre = filtres[nomFiltre];
    if (filtre.applicableEnfant) {
      listeFiltrePourEnfant[nomFiltre] = filtre;
    }
  });
  return listeFiltrePourEnfant;
}



// WEBPACK FOOTER //
// ./src/services/general/listeFilter.js